import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from 'components';
import styles from './RadioButtonBuilderAddOptionButton.scss';

const AddOptionButton = ({ onClick, isDisabled, label }) =>
    <Button
        className={styles.addButton}
        onClick={onClick}
        disabled={isDisabled}
        aria-label={label}
    >
        <Icon className={styles.addIcon} name='ion-md-add' />

        <div className={styles.iconText}>
            { label }
        </div>
    </Button>;

AddOptionButton.propTypes = {
    onClick: PropTypes.func,
    isDisabled: PropTypes.bool,
    label: PropTypes.string
};

AddOptionButton.defaultProps = {
    onClick: () => {},
    isDisabled: false,
    label: 'Add item'
};

export default AddOptionButton;
